import React, { useEffect } from 'react'
import { Button, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../components/Loader'
import Message from '../components/Message'
import Paginate from '../components/Paginate'
import { listOuterPosts, deleteOuterPost } from '../actions/mediaActions'
import { Helmet } from 'react-helmet-async'

function OuterPostListScreen({ history }) {

  const dispatch = useDispatch()

  const outerPostList = useSelector(state => state.outerPostList)
  const { loading, error, outerposts, page, pages } = outerPostList

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  const outerPostDelete = useSelector(state => state.outerPostDelete)
  const { success: successDelete } = outerPostDelete

  let keyword = history.location.search

  useEffect(() => {
    if (!userInfo || !userInfo.isAdmin) {
      history.push('/login')
    } else {
      dispatch(listOuterPosts(keyword))
    }
  }, [dispatch, history, userInfo, successDelete, keyword])

  const deleteHandler = (id) => {
    if (window.confirm('Sei sicuro di voler eliminare questo post del forum?')) {
      dispatch(deleteOuterPost(id))
    }
  }

  return (
    <div>
      <Helmet>
         <meta name="robots" content="noindex, follow" />
       </Helmet>
      <h1>Post del forum</h1>

      {loading ? <Loader />
        : error ? <Message variant='danger'>{error}</Message>
        :
        <div>
          <Table striped bordered hover responsive className='table-sm'>
            <thead>
              <tr>
                <th>Titolo</th>
                <th>Autore</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {outerposts.map(outerpost => (
                <tr key={outerpost._id}>
                  <td style={{maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                    {outerpost.title && outerpost.title.length > 60 ? outerpost.title.slice(0, 60) + '…' : outerpost.title}
                  </td>
                  <td>{outerpost.nickname}</td>
                  <td>
                    <Button variant='danger' className='btn-sm' onClick={() => deleteHandler(outerpost._id)}>
                      <i className='fas fa-trash'></i> Elimina
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Paginate page={page} pages={pages} keyword={keyword} basePath="/admin/outerpostlist"/>
        </div>
      }
    </div>
  )
}

export default OuterPostListScreen